import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";

/** Diálogo de cadastro/edição de disciplina. */
export default function DisciplinaForm({ disciplina, onClose, onSave, isSaving }) {
  const [descricao, setDescricao] = useState("");

  useEffect(() => {
    if (disciplina) setDescricao(disciplina.descricao ?? "");
  }, [disciplina]);

  const podeSalvar = descricao.trim() !== "" && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({ ...disciplina, descricao: descricao.trim() });
  };

  return (
    <Dialog open={Boolean(disciplina)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{disciplina?.codDisciplina ? "Editar Disciplina" : "Nova Disciplina"}</DialogTitle>
        <DialogContent>
          <TextField
            size="small"
            fullWidth
            required
            autoFocus
            margin="dense"
            label="Descrição"
            value={descricao}
            onChange={(event) => setDescricao(event.target.value)}
            helperText={`${descricao.length}/50`}
            slotProps={{ htmlInput: { maxLength: 50 } }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
